export class MitigatingActionReview {
  actionsRequired: string;
  controlEffective: number;
  controlTested: boolean;
  decisionReason: string;
  description: string;
  title: string;
  effectiveReason: string;
  id: number;
  mitigatingActionId: number;
  mitigationReviewDate: Date;
  notificationDate: Date;
  reviewUpdateDate: Date;
  riskId: number;
  status: number;
  updator: number;
}

export enum MitigationReviewStatus {
  PendingReview = 1,
  Overdue,
  Completed
}
